
import React from 'react';

const WhyUsSection = () => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
            Why Us
          </h2>
          
          <div className="text-lg text-gray-700 space-y-6 leading-relaxed">
            <p>
              At lawandcode.africa, we are committed to providing exceptional legal services 
              with a focus on artificial intelligence law, policy, and regulatory compliance. 
              Our expertise spans the complex intersection of AI technology and legal frameworks, 
              ensuring our clients navigate this evolving landscape with confidence.
            </p>
            
            <p>
              We pride ourselves on our deep understanding of AI governance, statutory provisions, 
              and their interaction with intellectual property, corporate governance, and commercial 
              law. Our approach combines cutting-edge legal knowledge with practical solutions 
              that address the unique challenges posed by artificial intelligence technologies.
            </p>
            
            <p>
              With a commitment to innovation and excellence in AI law, we continue to evolve 
              our practice to meet the changing needs of AI companies, startups, and organizations 
              implementing artificial intelligence solutions in an increasingly complex regulatory environment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
